export const AUTH_MESSAGES = {
  LOGIN_SUCCESS: 'Logged in successfully.',
  LOGIN_ERROR: 'Login failed. Please check your credentials.',
  // LOGOUT_SUCCESS: 'You have been logged out successfully.',
  SESSION_EXPIRED: 'Your session has expired. Please log in again.',
  INVALID_CREDENTIALS: 'Invalid Credentials.',
  ACCOUNT_LOCKED: 'Your account has been temporarily locked. Please contact support.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  DELETE_DOCUMENT_SUCCESS: 'Document deleted successfully.',
  DELETE_DOCUMENT_ERROR: 'Failed to delete document. Please try again.',
  DELETE_TEXT_SUCCESS: 'Text deleted successfully.',
  DELETE_TEXT_ERROR: 'Failed to delete text. Please try again.'
} as const;

export const SYSTEM_MESSAGES = {
  LOADING: 'Loading...',
  SAVING: 'Saving...',
  SUCCESS: 'Operation completed successfully.',
  ERROR: 'An error occurred. Please try again.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Server error. Please try again later.'
} as const;
